import { schemes, zSchema } from "@zeal/common";

export const voidTransactionRequestSchema = zSchema.object({
  id: schemes.uuid(),
  testMode: zSchema.boolean().optional(),
});

export type TVoidTransactionRequestSchema = zSchema.infer<
  typeof voidTransactionRequestSchema
>;

export const voidTransactionResponseSchema = zSchema.boolean();

export type TVoidTransactionResponseSchema = zSchema.infer<
  typeof voidTransactionResponseSchema
>;
